/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Agent_2_B3Inputs */

const en_mk_agent_2_b3 = /** @type {(inputs: Mk_Agent_2_B3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Every decision is recorded: who, when, and why`)
};

const id_mk_agent_2_b3 = /** @type {(inputs: Mk_Agent_2_B3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Setiap keputusan tercatat: siapa, kapan, dan alasannya`)
};

/**
* | output |
* | --- |
* | "Every decision is recorded: who, when, and why" |
*
* @param {Mk_Agent_2_B3Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_agent_2_b3 = /** @type {((inputs?: Mk_Agent_2_B3Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Agent_2_B3Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_agent_2_b3(inputs)
	return en_mk_agent_2_b3(inputs)
});